<template>
    <section class="">
      <b-row class="">
        <!-- Col: Left (Invoice Container) -->
        <b-col cols="12" xl="12" md="12">
          <b-card-actions action-collapse title="Detailed Booking">
            <b-row class="">
              <b-col cols="12" xl="12" md="12" class="mt-15">
                <h5>Reference</h5>
              </b-col>
              <b-col
                lg="12"
                md="12"
                sm="12"
                xs="12"
                cols="12"
              >
                <b-form-group label-for="reference">
                  <b-form-input
                    v-model="form.reference"
                    placeholder="Reference"
                    required
                    class="input-outline-bleu-border"
                    :readonly="true"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" xl="12" md="12" class="mt-30">
                <h5>Route</h5>
              </b-col>
              <b-col cols="12" xl="6" md="6">
                <b-form-input
                  id="item-from"
                  v-model="form.loadingPort"
                  label="title"
                  placeholder="From"
                  :readonly="true"
                ></b-form-input>
              </b-col>
              <b-col cols="12" xl="6" md="6">
                <b-form-input
                  id="item-To"
                  v-model="form.dischargePort"
                  label="title"
                  placeholder="To"
                  :readonly="true"
                ></b-form-input>
              </b-col>
  
              <b-col cols="12" xl="12" md="12" class="mt-15">
                <b-form-input
                  id="item-Incoterm"
                  v-model="form.incoterm"
                  label="item-Incoterm"
                  placeholder="Incoterm"
                  :readonly="true"
                >
                ></b-form-input>
              </b-col>
              <b-col
                lg="6"
                md="6"
                sm="6"
                xs="6"
                cols="12"
                class="mt-15"
                v-if="form.incoterm == 'EXW' || form.incoterm == 'FCA'"
              >
                <b-form-group label-for="Incoterm">
                <b-form-input
                    id="Incoterm"
                    v-model="form.transportType"
                    required
                    class="input-outline-bleu-border"
                    placeholder="Transport Type"
                    :readonly="true"
                    ></b-form-input>
                </b-form-group>
              </b-col>
  
              <b-col
                lg="6"
                md="6"
                sm="6"
                xs="6"
                cols="12"
                class="mt-15"
                v-if="
                  form.transportType == 'Transport Marchant' &&
                  (form.incoterm == 'EXW' || form.incoterm == 'FCA')
                "
              >
                <b-form-group label-for="departureAddressCity">
                  <b-form-input
                    v-model="form.departureAddressCity"
                    placeholder="Adresse Depart City"
                    required
                    class="input-outline-bleu-border"
                    :readonly="true"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col
                lg="6"
                md="6"
                sm="6"
                xs="6"
                cols="12"
                class="mt-15"
                v-if="form.incoterm == 'DAP'"
              >
                <b-form-group label-for="Incoterm">
                  <b-form-input
                    id="Incoterm"
                    v-model="form.transportType"
                    required
                    class="input-outline-bleu-border"
                    placeholder="Transport Type"
                    :readonly="true"
                  ></b-form-input>
                </b-form-group>
              </b-col>
  
              <b-col
                lg="6"
                md="6"
                sm="6"
                xs="6"
                cols="12"
                class="mt-15"
                v-if="
                  form.transportType == 'Transport Marchant' &&
                  form.incoterm == 'DAP'
                "
              >
                <b-form-group label-for="arrivalAddressCity">
                  <b-form-input
                    v-model="form.arrivalAddressCity"
                    placeholder="adresse Arrival City"
                    required
                    class="input-outline-bleu-border"
                    :readonly="true"
                  ></b-form-input>
                </b-form-group>
              </b-col>
  
              <b-col cols="12" xl="12" md="12" class="mt-30">
                <h5>Commodity/Container</h5>
              </b-col>
  <b-col cols="12" xl="12" md="12">
              <b-row v-for="(item, index) in form.commodityContainer" :key="index">
                <b-col cols="12" xl="12" md="12" class="mt-30">
                <h5>Commodity</h5>
              </b-col>
              <b-col cols="12" xl="12" md="12">
                <b-form-input
                  id="item-Commodity"
                  v-model="item.commodity.title"
                  label="title"
                  placeholder="Commodity"
                  :readonly="true"
                >
                </b-form-input>
              </b-col>
              <b-col cols="12" xl="12" md="12" class="mt-15">
                <b-form-group>
              
                                              <b-form-radio-group class="commodity-radio-group" :disabled="true">
                                                  <b-form-radio v-model="item.selectedOption" value="radio1">
                                                    Peperishable cargo requiring temperature control
                                                  </b-form-radio>
                                                  <b-form-radio v-model="item.selectedOption" value="radio2">
                                                    Cargo requiring special equipment
                                                  </b-form-radio>
                                                  <b-form-radio v-model="item.selectedOption" value="radio3">
                                                    Dangerous Cargo
                                                  </b-form-radio>
                                              </b-form-radio-group>
                                              </b-form-group> 
  
              </b-col>
              <b-col lg="12" md="12" sm="6" xs="12" cols="12" v-if="item.selectedOption=='radio1'">
                                              <b-form-group>
                                                  <b-form-input
                                                  id="temperature"
                                                  placeholder="Temperature"
                                                  v-model="item.commodity.temperatureControl"
                                                  class="input-outline-bleu-border"
                                                  :readonly="true"
                                                  ></b-form-input>
                                              </b-form-group>
                                          </b-col>
              <b-col lg="4" md="4" sm="6" xs="12" cols="12" v-if="item.selectedOption=='radio2'">
                                              <b-form-group>
                                                  <b-form-input
                                                  id="height"
                                                  placeholder="Height"
                                                  v-model="item.commodity.specialEquipment.height"
                                                  class="input-outline-bleu-border"
                                                  :readonly="true"
                                                  ></b-form-input>
                                              </b-form-group>
                                          </b-col>
                                          <b-col lg="4" md="4" sm="6" xs="12" cols="12" v-if="item.selectedOption=='radio2'">
                                              <b-form-group>
                                                  <b-form-input
                                                  id="width"
                                                  placeholder="Width"
                                                  v-model="item.commodity.specialEquipment.width"
                                                  class="input-outline-bleu-border"
                                                  :readonly="true"
                                                  ></b-form-input>
                                              </b-form-group>
                                          </b-col> 
                                          <b-col lg="4" md="4" sm="6" xs="12" cols="12" v-if="item.selectedOption=='radio2'">
                                              <b-form-group>
                                                  <b-form-input
                                                  id="length"
                                                  placeholder="Length"
                                                  v-model="item.commodity.specialEquipment.length"
                                                  class="input-outline-bleu-border"
                                                  :readonly="true"
                                                  ></b-form-input>
                                              </b-form-group>
                                          </b-col> 
              <b-col lg="6" md="6" sm="6" xs="12" cols="12" v-if="item.selectedOption=='radio3'">
                <b-form-group label-for="classe">
                  <b-form-input
                    id="classe"
                    v-model="item.commodity.commodityClass"
                    :readonly="true"
                    label="title"
                    placeholder="classe"
                    class="input-outline-bleu-border"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col lg="6" md="6" sm="6" xs="12" cols="12" v-if="item.selectedOption=='radio3'">
                <b-form-group label-for="un">
                  <b-form-input
                    id="un"
                    v-model="item.commodity.commodityUn"
                    :readonly="true"
                    placeholder="UN"
                    label="title"
                    class="input-outline-bleu-border"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" xl="12" md="12" class="mt-30">
                <h5>Container</h5>
              </b-col>
                <b-col  lg="4" md="4" sm="6" xs="12" cols="12">
                  <b-form-group label-for="container">
                    <b-form-input
                      id="container"
                      v-model="item.container.containerType"
                      placeholder="Container type"
                      class="input-outline-bleu-border"
                      :readonly="true"
                    ></b-form-input>
                  </b-form-group>
  
                  <b-form-group >
                    <b-form-checkbox value="true" v-model="item.container.isOwnedByShipper" :disabled="true"
                      >Shipper owned container</b-form-checkbox
                    >
                  </b-form-group>
                </b-col>
                <b-col lg="4" md="4" sm="6" xs="12" cols="12">
                  <b-form-group
                    label-for="Container-qte"
                  >
                    <b-form-spinbutton
                      id="Container-qte"
                      v-model="item.container.quantity"
                      min="1"
                      max="100000"
                      class="input-outline-bleu-border"
                      :disabled="true"
                    ></b-form-spinbutton>
                  </b-form-group>
                </b-col>
                <b-col lg="4" md="4" sm="6" xs="12" cols="12">
                  <b-form-group
                    label-for="Container-quantity"
                  >
                    <b-form-input
                      placeholder="Container weight ( kg )"
                      v-model="item.container.weight"
                      :readonly="true"
                      required
                      id="Container-quantity"
                      class="input-outline-bleu-border"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
               </b-col>
  
                <b-col cols="12" xl="12" md="12" class="mt-30">
                <h5>Date</h5>
              </b-col>
              <b-col cols="12" xl="6" md="6" >
                  <b-form-datepicker
                    id="Effective-datepicker"
                    v-model="form.effectiveDate"
                    class="mb-1"
                    placeholder="Effective date"
                    :readonly="true"
                  />
              </b-col>
              <b-col cols="12" xl="6" md="6" >
                      <b-form-datepicker
                        id="Expiry-datepicker"
                        v-model="form.expiryDate"
                        class="mb-1"
                        placeholder="Expiry date"
                        :readonly="true"
                      />
              </b-col>
              <b-col cols="12" xl="12" md="12" class="mt-30">
                <h5>Price Owner</h5>
              </b-col>
              <b-col lg="5" md="6" sm="6" xs="12" cols="12">
                <b-form-group v-slot="{ ariaDescribedby }">
                  <b-form-radio v-model="selectedOption" :aria-describedby="ariaDescribedby" name="customer" value="iamPriceOwner" class="mb-1" :disabled="true">I am the price Owner</b-form-radio>
                  <b-form-radio v-model="selectedOption" :aria-describedby="ariaDescribedby" name="priceOwner" value="selectPriceOwner" :disabled="true">Select a price Owner</b-form-radio>
                </b-form-group>
              </b-col>
              <b-row v-if="selectedOption === 'selectPriceOwner'" class="customer-row">  
                <b-col cols="12" xl="12" md="12" class="mt-30">
                                            <h5>Customer Code</h5>
                                          </b-col>                      
                                             <b-col lg="12" md="12" sm="12" xs="12" cols="12">                                                                                   
                                                      <b-form-group label-for="customerCode">
                                                          <b-form-input
                                                          id="customerCode"
                                                          v-model="form.customerCode"
                                                          placeholder="Customer Code"
                                                          required
                                                          class="input-outline-bleu-border"
                                                          :readonly="true"
                                                          ></b-form-input>
                                                      </b-form-group>
                                              </b-col>
  
                                               <b-col lg="5" md="5" sm="12" xs="12" cols="12" class="mt-25 mb-25">
                                                 <hr>
                                              </b-col>
                                              <b-col  lg="1" md="1" sm="1" xs="12" cols="12" class="mt-25 mb-25">Or</b-col>
                                              <b-col lg="6" md="5" sm="12" xs="12" cols="12" class="mt-25 mb-25">
                                                 <hr>
                                              </b-col>
                                           
                                              <b-col lg="6" md="6" sm="6" xs="6" cols="12">
                                                <b-col cols="12" xl="6" md="6" class="mt-30">
                                            <h5>Company Name</h5>
                                          </b-col>
                                                  <b-form-group label-for="companyName" >
                                                          <b-form-input
                                                          v-model="form.companyName"
                                                          placeholder="Company Name"
                                                          required
                                                          class="input-outline-bleu-border"
                                                          :readonly="true"
                                                          ></b-form-input>
                                                      </b-form-group>
                                               </b-col>
                                           
                                                <b-col lg="6" md="6" sm="6" xs="6" cols="12">
                                                  <b-col cols="12" xl="6" md="6" class="mt-30">
                                            <h5>Country</h5>
                                          </b-col>
                                                  <b-form-group label-for="country">
                                                      <b-form-input
                                                      id="country"
                                                      v-model="form.country"
                                                      placeholder="Country"
                                                      required
                                                       class="input-outline-bleu-border"
                                                       :readonly="true"
                                                      ></b-form-input>
                                                 </b-form-group>
                                              </b-col>
                                            
                                              <b-col lg="6" md="6" sm="6" xs="6" cols="12" >
                                                <b-col cols="12" xl="12" md="12" class="mt-30">
                                            <h5>Postal/Zip code(Optional)</h5>
                                          </b-col>
                                                  <b-form-group label-for="postal" >
                                                          <b-form-input
                                                          v-model="form.zipCode"
                                                          placeholder="Postal/Zip code"
                                                          class="input-outline-bleu-border"
                                                          :readonly="true"
                                                          ></b-form-input>
                                                      </b-form-group>
                                               </b-col>
                                              
                                                <b-col lg="6" md="6" sm="6" xs="6" cols="12">
                                                  <b-col cols="12" xl="12" md="12" class="mt-30">
                                            <h5>Street name(Optional)</h5>
                                          </b-col>
                                                   <b-form-group label-for="streetName" >
                                                          <b-form-input
                                                          v-model="form.streetName"
                                                          placeholder="Street name"
                                                          class="input-outline-bleu-border"
                                                          :readonly="true"
                                                          ></b-form-input>
                                                      </b-form-group>
                                              </b-col>
                                               <b-col lg="6" md="6" sm="6" xs="6" cols="12" >
                                                <b-col cols="12" xl="12" md="12" class="mt-30">
                                            <h5>P.O. Box(Optional)</h5>
                                          </b-col>
                                                  <b-form-group label-for="POBox" >
                                                          <b-form-input
                                                          v-model="form.POBox"
                                                          placeholder="P.O. Box"
                                                          class="input-outline-bleu-border"
                                                          :readonly="true"
                                                          ></b-form-input>
                                                      </b-form-group>
                                               </b-col>
                                                <b-col lg="6" md="6" sm="6" xs="6" cols="12">
                                                  <b-col cols="12" xl="12" md="12" class="mt-30">
                                            <h5>Street number(Optional)</h5>
                                          </b-col>
                                                   <b-form-group label-for="streetNumber" >
                                                          <b-form-input
                                                          v-model="form.streetNumber"
                                                          placeholder="Street number"
                                                          class="input-outline-bleu-border"
                                                          :readonly="true"
                                                          ></b-form-input>
                                                      </b-form-group>
                                              </b-col>                                        
                                      </b-row> 
            </b-row>
          </b-card-actions>
        </b-col>
      </b-row>
    </section>
</template>

<script>
import Logo from "@core/layouts/components/Logo.vue";
import { heightTransition } from "@core/mixins/ui/transition";
import Ripple from "vue-ripple-directive";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";

import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BButton,
  BCardText,
  BForm,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BFormTextarea,
  BFormCheckbox,
  BPopover,
  VBToggle,
  BFormSpinbutton,
  BFormDatepicker,
  BFormRadioGroup,
  BFormRadio
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import SidebarAddNewCustomer from "../../composants/sidebar/SidebarAddNewCustomer.vue";
import SidebarAddNewAgency from "../../composants/sidebar/SidebarAddNewAgency.vue";
import SidebarAddNewCommodity from "../../composants/sidebar/SidebarAddNewCommodity.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import axios from "@axios";

export default {
  components: {
    BFormDatepicker,
    BFormSpinbutton,
    BCardActions,
    BRow,
    BCol,
    BCard,
    BCardBody,
    BButton,
    BCardText,
    BForm,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BFormTextarea,
    BFormCheckbox,
    BPopover,
    flatPickr,
    vSelect,
    Logo,
    SidebarAddNewCustomer,
    SidebarAddNewAgency,   
    SidebarAddNewCommodity,
    ToastificationContent,
    BFormRadioGroup,
    BFormRadio
  },
  data() {
    return {
      form : {
            reference : null,
            quotation:this.$router.history.current.query.id,
            customer:JSON.parse(localStorage.getItem("userData"))._id,
            loadingPort: null,
            dischargePort: null,
            incoterm:null,
            transportType:null,
            departureAddressCity:null,
            TransportDischarge:null,
            arrivalAddressCity:null,
            commodityContainer : [
                {
                    selectedOption : null,
                    commodity : {
                        title : null,
                        description : null,
                        requiresTemperatureControl: false,
                        requiresSpecialEquipment:false,
                        dangerousCargo:false,
                        commodityClass: null,
                        commodityUn: null,
                        temperatureControl: null,
                        specialEquipment : {
                            height: null,
                            width: null,
                            length: null,
                        },              
                    },
                    container: {
                      containers : [],
                        containerType: null,
                        quantity: 1,
                        weight: '1000.000',
                        isOwnedByShipper: false,
                    }
                }
            ],
            effectiveDate: null,
            expiryDate: null,
            customerCode: '',
            companyName: '',
            country: '',
            zipCode: '', 
            streetName: '',
            POBox: '',
            streetNumber: '',
            merchandiseType: null,
        },
      selectedOption : null, 
    }
},
    created() {
        this.getBooking()
    },
    methods: {
        async getBooking() {
        const response = await axios.get(
            "https://mtl-feeder-nodejs.onrender.com/api/bookings?id="+this.$router.history.current.query.id
        );
        this.form=response.data.data
        this.form.commodityContainer.forEach((element, index) => {
            if (element.commodity.requiresTemperatureControl) {
              this.form.commodityContainer[index].selectedOption = 'radio1';
            }
            if (element.commodity.requiresSpecialEquipment) {
              console.log("j")
                this.form.commodityContainer[index].selectedOption = 'radio2';
            }
            if (element.commodity.dangerousCargo) {
              this.form.commodityContainer[index].selectedOption = 'radio3';
            }
        });
        if (this.form.customerCode  || this.form.companyName || this.form.country) {
            this.selectedOption = "selectPriceOwner"
        } 
        else {
            this.selectedOption = "iamPriceOwner"
        }
        },
    }
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
.commodity-radio-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 10px;
}
</style>
